// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_landing3 = /** @type {(inputs: {}) => string} */ () => {
	return `air`
};

const el_landing3 = /** @type {(inputs: {}) => string} */ () => {
	return `αέρα`
};

const ru_landing3 = /** @type {(inputs: {}) => string} */ () => {
	return `воздуху`
};

const he_landing3 = /** @type {(inputs: {}) => string} */ () => {
	return `אוויר`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const landing3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing3", locale)
	if (locale === "en") return en_landing3(inputs)
	if (locale === "el") return el_landing3(inputs)
	if (locale === "ru") return ru_landing3(inputs)
	if (locale === "he") return he_landing3(inputs)
	return "landing3"
};